import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { NotificationKeys } from '../../../../../enums/notificationKeys'
import { APIError } from '../../../../../utils'
import { updateAccountFromTemplate } from '../query-api'

interface UseUpdateAccountFromTemplateProps {
  onError?: (error: APIError) => void
  onSuccess?: () => void
}

export const useUpdateAccountFromTemplate = ({ onError, onSuccess }: UseUpdateAccountFromTemplateProps) => {
  const { t } = useTranslation()
  const { mutate: updateAccount, isLoading: isProcessing } = useMutation(updateAccountFromTemplate, {
    onError: (error: APIError) => {
      onError?.(error)
      notify({
        id: NotificationKeys.AccountFromTemplateUpdate,
        message: error.body?.errorMessage || t('error_saving'),
        variant: 'error',
      })
    },
    onSuccess: () => {
      onSuccess?.()
      notify({
        id: NotificationKeys.AccountFromTemplateUpdate,
        message: t('coa.account_from_base_form.edit.success_message'),
        variant: 'success',
      })
    },
  })

  return { isProcessing, updateAccount }
}
